import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { setPageTitle, setMetaTags } from '../utils/seoUtils';
import './LegalPage.css';

function Ads() {
  // SEO設定
  useEffect(() => {
    setPageTitle('広告掲載について');
    setMetaTags({
      title: '広告掲載について | デリヘル専用SNS「DNS」 - 女の子との新しいコミュニケーションツール（風俗ポータル）',
      description: 'デリヘル専用SNS「DNS」での広告掲載に関する情報、広告の種類、ターゲット広告、広告主向け情報について詳しく説明しています。広告掲載をご検討の企業様はこちらをご覧ください。',
      type: 'website',
      url: 'https://deli-ns.com/ads'
    });
  }, []);
  return (
    <div className="legal-page">
      <div className="legal-page__container">
        <h1>広告情報</h1>
        <p className="legal-page__updated">最終更新日: 2025年6月30日</p>

        <section>
          <h2>1. 広告サービス</h2>
          <p>当社のサービスでは、ユーザー体験の向上とサービスの維持のために広告を表示しています。本ページでは、当社の広告サービスに関する情報と、広告に関するユーザーの選択肢について説明します。</p>
        </section>

        <section>
          <h2>2. 広告の種類</h2>
          <p>当社のプラットフォームでは、以下の種類の広告を表示する場合があります：</p>
          <ul>
            <li><strong>ディスプレイ広告：</strong> サービス内の指定された場所に表示されるバナー広告や画像広告</li>
            <li><strong>テキスト広告：</strong> コンテンツフィード内に表示されるテキストベースの広告</li>
            <li><strong>スポンサー付きコンテンツ：</strong> 企業や団体がスポンサーとなって作成されたコンテンツ</li>
          </ul>
        </section>

        <section>
          <h2>3. ターゲット広告</h2>
          <p>当社は、より関連性の高い広告を提供するために、以下の情報に基づいてターゲット広告を表示することがあります：</p>
          <ul>
            <li>ユーザーが当社のサービス上で行った活動（閲覧したページ、クリックした広告など）</li>
            <li>ユーザーのプロフィール情報（年齢、性別、居住地域など）</li>
            <li>ユーザーの興味・関心（フォローしているトピックやアカウントなど）</li>
            <li>サードパーティから提供される情報（広告主のデータなど）</li>
          </ul>
          <p>当社がこれらの情報をどのように収集・利用するかについての詳細は、<Link to="/privacy">プライバシーポリシー</Link>をご参照ください。</p>
        </section>

        <section>
          <h2>4. 広告に関するユーザーの選択肢</h2>
          <p>ユーザーには、当社の広告表示に関して以下の選択肢があります：</p>
          <ul>
            <li><strong>広告トラッキングのオプトアウト：</strong> 一部の広告ネットワークでは、広告トラッキングからのオプトアウトを提供しています</li>
          </ul>
        </section>

        <section>
          <h2>5. 広告主向け情報</h2>
          <p>当社のプラットフォーム上で広告を掲載することに興味がある企業や店舗は、以下の点にご注意ください：</p>
          <ul>
            <li>すべての広告は、当社の広告ポリシーに準拠する必要があります</li>
            <li>禁止されている広告コンテンツには、誤解を招く情報、不適切な内容、違法な製品やサービスの宣伝などが含まれます</li>
            <li>広告の効果測定のため、当社は広告パフォーマンスに関するデータを提供します</li>
          </ul>
          <p>広告掲載に関する詳細は、<a href="mailto:ads@deli-ns.com">ads@deli-ns.com</a>までお問い合わせください。</p>
        </section>

        <section>
          <h2>6. 変更</h2>
          <p>当社は、必要に応じて本広告情報を変更することがあります。変更があった場合は、本サービス上で通知します。</p>
        </section>

        <section>
          <h2>7. 連絡先</h2>
          <p>広告に関するご質問やお問い合わせは、<a href="mailto:ads@deli-ns.com">ads@deli-ns.com</a>までご連絡ください。</p>
        </section>

        <div className="legal-page__footer">
          <Link to="/" className="legal-page__back">ホームに戻る</Link>
        </div>
      </div>
    </div>
  );
}

export default Ads; 